import { Message } from "@queries/ai.query";
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface Props {
  message: Message;
  isUser: boolean;
  userAvatar?: string;
}

const ChatMessage: React.FC<Props> = ({ message, isUser, userAvatar }) => {
  return (
    <div
      className={`flex w-full items-end ${isUser ? "justify-end" : "justify-start"} gap-1 mb-4`}
    >
      {!isUser && (
        <img
          alt=""
          src="/images/bot_tab@3x.png"
          className="w-8 h-8 rounded-full mr-2 self-end object-cover"
        />
      )}
      <div
        className={`rounded-2xl px-3 py-2 text-sm leading-6 ${
          isUser
            ? "bg-[#1054B5] text-white rounded-br-sm"
            : "bg-gray-100 text-gray-900 rounded-bl-sm"
        }`}
        style={{ maxWidth: "79%" }}
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            h1: ({ children }) => (
              <h1 className="font-semibold text-lg my-2">{children}</h1>
            ),
            h2: ({ children }) => (
              <h2 className="font-semibold text-base my-2">{children}</h2>
            ),
            h3: ({ children }) => (
              <h3 className="font-semibold my-2">{children}</h3>
            ),
            p: ({ children }) => <p className="mb-1">{children}</p>,
            strong: ({ children }) => <strong>{children}</strong>,
            em: ({ children }) => <em>{children}</em>,
            code: ({ className, children, ...props }) => {
              const isInline = !className;
              if (isInline) {
                return (
                  <code className="bg-gray-200 rounded px-1 py-0.5" {...props}>
                    {children}
                  </code>
                );
              }
              return (
                <pre className="whitespace-pre-wrap overflow-x-auto bg-black/90 text-white rounded-md p-3 my-2">
                  <code {...props}>{children}</code>
                </pre>
              );
            },
            a: ({ href, children, ...props }) => (
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                className="text-blue-600 underline break-words break-all hover:text-blue-700 font-medium"
                style={{
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                  color: "#2563eb",
                }}
                {...props}
              >
                {children}
              </a>
            ),
            ul: ({ children }) => (
              <ul className="my-2 ml-4 list-disc">{children}</ul>
            ),
            ol: ({ children }) => (
              <ol className="my-2 ml-4 list-decimal">{children}</ol>
            ),
            li: ({ children }) => <li className="mb-1">{children}</li>,
            br: () => <br />,
          }}
        >
          {message.content || ""}
        </ReactMarkdown>
      </div>
      {isUser && (
        <img
          alt=""
          src={userAvatar || "/images/default_image.png"}
          className="w-6 h-6 rounded-full self-end object-cover"
          style={{ marginLeft: "2px" }}
        />
      )}
    </div>
  );
};

export default ChatMessage;
